import { render, staticRenderFns } from "./Grafico.vue?vue&type=template&id=a1b06dce&scoped=true"
import script from "./Grafico.vue?vue&type=script&lang=js"
export * from "./Grafico.vue?vue&type=script&lang=js"
import style0 from "./Grafico.vue?vue&type=style&index=0&id=a1b06dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b06dce",
  null
  
)

export default component.exports